





















import { Component, Prop, Mixins } from 'vue-property-decorator';
import { FieldComponent, FormFieldElement } from '@/types/FieldComponent';
import LayoutMixin from '@/mixins/LayoutMixin';
import { findFieldComponent } from '@/utils/form';

@Component
export default class PreviewForm extends Mixins(LayoutMixin) {
  @Prop({ default: () => ({}) })
  readonly previewData!: Record<string, any>;

  @Prop()
  readonly fieldComponents!: FieldComponent[];

  get formLayoutFieldComponents(): FormFieldElement[] {
    return this.previewLayoutFields.map((layoutElement) => findFieldComponent(layoutElement, this.fieldComponents));
  }

  previewFieldValue(name: string): any {
    return this.previewData[name];
  }
}
